import {StyledDialog} from './style'
import {AgendaEventDetailsErrorDialog} from './AgendaEventDetailsErrorDialog'
import {AgendaEventDetailsLoaderDialog} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsLoaderDialog'
import {useAgendaEvent} from '@/features/agenda/hooks/useAgendaEvent'
import {AgendaEventDetailsAppointmentDialogContent} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsAppointmentDialogContent'
import {AgendaEventDetailsGenericDialogContent} from '@/features/agenda/components/agenda-event-details-dialog/AgendaEventDetailsGenericDialogContent'

export const AgendaEventDetailsDialog = ({eventId}: {eventId: string}) => {
    return (
        <StyledDialog width="680px" overflowY="visible">
            <AgendaEventDetailsFormDialogContent eventId={eventId} />
        </StyledDialog>
    )
}

const AgendaEventDetailsFormDialogContent = ({eventId}: {eventId: string}) => {
    const {agendaEvent, agendaEventDefaultValues, data, error, refetch, isPending, isFetching, isError} =
        useAgendaEvent({
            eventId
        })

    if (isFetching || isPending) {
        return <AgendaEventDetailsLoaderDialog />
    }

    if (isError || !agendaEvent || (agendaEvent.type !== 'event' && agendaEvent.type !== 'generic_event')) {
        return <AgendaEventDetailsErrorDialog error={error} refetch={refetch} isFetching={isFetching} />
    }

    if (agendaEvent.type === 'generic_event') {
        return <AgendaEventDetailsGenericDialogContent agendaEvent={agendaEvent} />
    }

    if (!agendaEventDefaultValues || !data) {
        return <AgendaEventDetailsErrorDialog error={error} refetch={refetch} isFetching={isFetching} />
    }

    return (
        <AgendaEventDetailsAppointmentDialogContent
            agendaEvent={agendaEvent}
            agendaEventDefaultValues={agendaEventDefaultValues}
            data={data}
        />
    )
}
